export default __webpack_public_path__ + "25c09f6807883283fe1561ebd74b0fcd.svg";